module.exports = __webpack_public_path__ + "img/eq-gloves.3a8877ac.png";